/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TemplateVariantUpdateProtocolQueryVariables = Types.Exact<{
  entryTemplateId: Types.Scalars['ID']['input'];
  toVersionNumber: Types.Scalars['Int']['input'];
}>;


export type TemplateVariantUpdateProtocolQuery = { templateVariantUpdateProtocol: { __typename: 'MissingPermissions' } | { __typename: 'TemplateVariantUpdateProtocolResult', protocol?: { __typename: 'TemplateVariantUpdateProtocol', entries: Array<{ __typename: 'TemplateVariantUpdateProtocolEntry', id: string, fromVersionNumber: number, toVersionNumber: number, problemPart: Types.TemplateVariantUpdateProtocolEntryProblemPart, problemReason: string, problemPropKey?: string | null, problemAttributeName?: string | null, templateTitle: string, fromItemTitle: string, toItemTitle?: string | null, entryTemplateId: string, templateId: string, itemId: string }> } | null } };

export type TemplateVariantUpdateProtocolEntryFragment = { __typename: 'TemplateVariantUpdateProtocolEntry', id: string, fromVersionNumber: number, toVersionNumber: number, problemPart: Types.TemplateVariantUpdateProtocolEntryProblemPart, problemReason: string, problemPropKey?: string | null, problemAttributeName?: string | null, templateTitle: string, fromItemTitle: string, toItemTitle?: string | null, entryTemplateId: string, templateId: string, itemId: string };

export const TemplateVariantUpdateProtocolEntryFragmentDoc = gql`
    fragment TemplateVariantUpdateProtocolEntry on TemplateVariantUpdateProtocolEntry {
  id
  fromVersionNumber
  toVersionNumber
  problemPart
  problemReason
  problemPropKey
  problemAttributeName
  templateTitle
  fromItemTitle
  toItemTitle
  entryTemplateId
  templateId
  itemId
}
    `;
export const TemplateVariantUpdateProtocolDocument = gql`
    query TemplateVariantUpdateProtocol($entryTemplateId: ID!, $toVersionNumber: Int!) {
  templateVariantUpdateProtocol(
    entryTemplateId: $entryTemplateId
    toVersionNumber: $toVersionNumber
  ) {
    ... on TemplateVariantUpdateProtocolResult {
      protocol {
        entries {
          id
          ...TemplateVariantUpdateProtocolEntry
        }
      }
    }
  }
}
    ${TemplateVariantUpdateProtocolEntryFragmentDoc}`;

/**
 * __useTemplateVariantUpdateProtocolQuery__
 *
 * To run a query within a React component, call `useTemplateVariantUpdateProtocolQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplateVariantUpdateProtocolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateVariantUpdateProtocolQuery({
 *   variables: {
 *      entryTemplateId: // value for 'entryTemplateId'
 *      toVersionNumber: // value for 'toVersionNumber'
 *   },
 * });
 */
export function useTemplateVariantUpdateProtocolQuery(baseOptions: Apollo.QueryHookOptions<TemplateVariantUpdateProtocolQuery, TemplateVariantUpdateProtocolQueryVariables> & ({ variables: TemplateVariantUpdateProtocolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateVariantUpdateProtocolQuery, TemplateVariantUpdateProtocolQueryVariables>(TemplateVariantUpdateProtocolDocument, options);
      }
export function useTemplateVariantUpdateProtocolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplateVariantUpdateProtocolQuery, TemplateVariantUpdateProtocolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateVariantUpdateProtocolQuery, TemplateVariantUpdateProtocolQueryVariables>(TemplateVariantUpdateProtocolDocument, options);
        }
export function useTemplateVariantUpdateProtocolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateVariantUpdateProtocolQuery, TemplateVariantUpdateProtocolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateVariantUpdateProtocolQuery, TemplateVariantUpdateProtocolQueryVariables>(TemplateVariantUpdateProtocolDocument, options);
        }
export type TemplateVariantUpdateProtocolQueryHookResult = ReturnType<typeof useTemplateVariantUpdateProtocolQuery>;
export type TemplateVariantUpdateProtocolLazyQueryHookResult = ReturnType<typeof useTemplateVariantUpdateProtocolLazyQuery>;
export type TemplateVariantUpdateProtocolSuspenseQueryHookResult = ReturnType<typeof useTemplateVariantUpdateProtocolSuspenseQuery>;
export type TemplateVariantUpdateProtocolQueryResult = Apollo.QueryResult<TemplateVariantUpdateProtocolQuery, TemplateVariantUpdateProtocolQueryVariables>;